export default "__VITE_ASSET__eD8MeTed__"